import { render, staticRenderFns } from "./NavigationPage.vue?vue&type=template&id=131eb9b6&scoped=true"
var script = {}
import style0 from "./NavigationPage.vue?vue&type=style&index=0&id=131eb9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131eb9b6",
  null
  
)

export default component.exports